import React, { useState, useEffect } from "react";
import axios from "axios";

import routes from "../../../app/routes";
import Invoice from "./Invoices/Invoice";
import { Row } from "react-bootstrap";

export default function Invoices() {
  const [collection, setCollection] = useState([]);
  const [loaded, setLoaded] = useState(true);

  const updateCollection = () => {
    setLoaded(true);
    axios.get(routes.api.member_cycle_invoices.list).then((resp) => {
      setLoaded(false);

      setCollection(resp.data.data);
    });
  };

  useEffect(() => {
    updateCollection();
  }, []);

  return (
    <>
      <div className="top-header-info">
        <div className="row">
          <div className="col-md-12">
            <h2>Invoices</h2>
            <hr />
          </div>
        </div>
      </div>

      <div className="mt10">
        <Row className="invoice-list">
          {collection.map((invoice, index) => (
            <Invoice key={invoice.id} invoice={invoice} />
          ))}
        </Row>
      </div>
    </>
  );
}
